<template>
  <div class="billing-page">
    <h1>💳 サブスクリプション</h1>
    <p class="desc">有料プランに登録して、学習をスタートしましょう。</p>

    <div class="plans">
      <div class="card">
        <h2>オトエイゴ Standard</h2>
        <p class="price">¥9,800 / 月</p>
        <p class="trial">登録後72時間は無料</p>
        <button class="btn" :disabled="isLoading" @click="startCheckout">
          {{ isLoading ? 'リダイレクト中...' : '登録する' }}
        </button>
      </div>
    </div>
    <p class="note">テストモードでは実際の課金は行われません。</p>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { supabase } from '../supabaseClient'

const isLoading = ref(false)

const startCheckout = async () => {
  try {
    isLoading.value = true

    const { data: { user } } = await supabase.auth.getUser()
    if (!user?.id) {
      alert('ログインが必要です')
      isLoading.value = false
      return
    }

    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://api.otoeigo.com'
    // Price はバックエンド getDefaultCheckoutPriceIdFromEnv()（STRIPE_PRICE_WEEKDAY 優先）に一元化
    const res = await fetch(`${apiBaseUrl}/api/create-checkout-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: user.id, plan: 'standard' })
    })

    const data = await res.json()
    if (!res.ok || !data?.success) {
      throw new Error(data?.error || 'セッション作成に失敗しました')
    }

    window.location.href = data.url
  } catch (error) {
    console.error(error)
    alert('チェックアウトに失敗しました: ' + error.message)
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
.billing-page {
  max-width: 640px;
  margin: 2rem auto;
  padding: 0 1rem;
  text-align: left;
}
.desc { color: #556; }
.card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.25rem;
  margin-top: 1rem;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
}
.price { font-weight: 600; margin: .25rem 0 1rem; }
.btn {
  background: #635bff;
  color: #fff;
  border: none;
  padding: .75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
}
.btn:disabled { opacity: .6; cursor: not-allowed; }
.note { color: #667085; font-size: .85rem; margin-top: .75rem; }
</style>
